import React, { useState, useEffect } from 'react';
import { HighChartModel, LineChartDataModel, LineChartSeriesModel } from '@models/highChartsModel';
import { BaseChart } from '@classes/options/chart/baseChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import LoaderComponent from '../layout/loader';
import { FadeLoader } from 'react-spinners';
import DataTable from 'react-data-table-component';

const LineChartAtom: React.FC<{ chartData: LineChartDataModel | null; height: string; isLoading: boolean }> = ({
  chartData,
  height,
  isLoading,
}) => {
  const [chartOption, setChartOption] = useState<HighChartModel>(null);

  const createOptions = (series, xAxis, yAxis): HighChartModel => {
    return {
      ...new BaseChart().setBasicHighChartOption(),
      chart: {
        type: 'line',
      },
      xAxis,
      series,
      yAxis,
    };
  };

  useEffect(() => {
    if (chartData) {
      const { series, xAxis, yAxis } = chartData;
      setChartOption(createOptions(series, xAxis, yAxis));
    }
  }, [chartData]);

  return (
    <>
      {isLoading ? (
        <LoaderComponent height={height}>
          <FadeLoader />
        </LoaderComponent>
      ) : !!chartOption?.series && chartOption?.series.length > 0 ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOption}
          containerProps={height && { style: { height: height } }}
          updateArgs={[true, true, true]}
        />
      ) : (
        <DataTable data={[]} columns={[]} />
      )}
    </>
  );
};

export default LineChartAtom;
